// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-icon-btn {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-icon-btn--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-icon-btn {
  border-radius: 50%;
}
:where(.vuetify-styles) .v-icon-btn:hover > .v-icon-btn__overlay {
  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-icon-btn:focus-visible > .v-icon-btn__overlay {
  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-icon-btn:focus > .v-icon-btn__overlay {
    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-icon-btn--active > .v-icon-btn__overlay, :where(.vuetify-styles) .v-icon-btn[aria-haspopup=menu][aria-expanded=true] > .v-icon-btn__overlay {
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-icon-btn--active:hover > .v-icon-btn__overlay, :where(.vuetify-styles) .v-icon-btn[aria-haspopup=menu][aria-expanded=true]:hover > .v-icon-btn__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-icon-btn--active:focus-visible > .v-icon-btn__overlay, :where(.vuetify-styles) .v-icon-btn[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-icon-btn__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-icon-btn--active:focus > .v-icon-btn__overlay, :where(.vuetify-styles) .v-icon-btn[aria-haspopup=menu][aria-expanded=true]:focus > .v-icon-btn__overlay {
    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-icon-btn--variant-plain, :where(.vuetify-styles) .v-icon-btn--variant-outlined, :where(.vuetify-styles) .v-icon-btn--variant-text, :where(.vuetify-styles) .v-icon-btn--variant-tonal {
  background: transparent;
  color: inherit;
}
:where(.vuetify-styles) .v-icon-btn--variant-plain {
  opacity: 0.62;
}
:where(.vuetify-styles) .v-icon-btn--variant-plain:focus, :where(.vuetify-styles) .v-icon-btn--variant-plain:hover {
  opacity: 1;
}
:where(.vuetify-styles) .v-icon-btn--variant-plain .v-icon-btn__overlay {
  display: none;
}
:where(.vuetify-styles) .v-icon-btn--variant-elevated, :where(.vuetify-styles) .v-icon-btn--variant-flat {
  background: rgb(var(--v-theme-surface));
  color: inherit;
}
:where(.vuetify-styles) .v-icon-btn--variant-elevated {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-icon-btn--variant-flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-icon-btn--variant-outlined {
  border: thin solid currentColor;
}
:where(.vuetify-styles) .v-icon-btn--variant-text .v-icon-btn__overlay {
  background: currentColor;
}
:where(.vuetify-styles) .v-icon-btn--variant-tonal .v-icon-btn__underlay {
  background: currentColor;
  opacity: var(--v-activated-opacity);
  border-radius: inherit;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
:where(.vuetify-styles) .v-icon-btn .v-icon-btn__underlay {
  position: absolute;
}
:where(.vuetify-styles) .v-icon-btn {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  flex: none;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: normal;
  height: var(--v-icon-btn-height);
  justify-content: center;
  outline: none;
  position: relative;
  transition-property: width, height, transform;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  vertical-align: middle;
  width: var(--v-icon-btn-width);
}
@supports selector(:focus-visible) {
  :where(.vuetify-styles) .v-icon-btn::after {
    pointer-events: none;
    border: 2px solid currentColor;
    border-radius: inherit;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  :where(.vuetify-styles) .v-icon-btn::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  :where(.vuetify-styles) .v-icon-btn:focus-visible::after {
    opacity: calc(0.25 * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-icon-btn--disabled, :where(.vuetify-styles) .v-icon-btn--loading, :where(.vuetify-styles) .v-icon-btn--readonly {
  pointer-events: none;
}
:where(.vuetify-styles) .v-icon-btn--disabled {
  opacity: 0.26;
}
:where(.vuetify-styles) .v-icon-btn--start {
  margin-inline-end: 8px;
}
:where(.vuetify-styles) .v-icon-btn--end {
  margin-inline-start: 8px;
}

:where(.vuetify-styles) .v-icon-btn__content {
  align-items: center;
  justify-content: center;
  display: inline-flex;
  transition: inherit;
  transition-property: transform;
  transform: rotate(var(--v-icon-btn-rotate, 0deg));
}
:where(.vuetify-styles) .v-icon-btn--loading .v-icon-btn__content {
  opacity: 0;
}
:where(.vuetify-styles) .v-icon-btn__content .v-icon {
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: opacity, font-size, width, height;
  transform-origin: center;
}

:where(.vuetify-styles) .v-icon-btn__loader {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

:where(.vuetify-styles) .v-icon-btn__overlay,
:where(.vuetify-styles) .v-icon-btn__underlay {
  border-radius: inherit;
  pointer-events: none;
}
:where(.vuetify-styles) .v-icon-btn__overlay,
:where(.vuetify-styles) .v-icon-btn__underlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

:where(.vuetify-styles) .v-icon-btn__overlay {
  background-color: currentColor;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
:where(.vuetify-styles) .v-icon-btn--active:not(:hover) .v-icon-btn__overlay {
  --v-activated-opacity: 0;
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-icon-btn:focus-visible {
    outline: 2px solid;
    outline-offset: 2px;
  }
  :where(.vuetify-styles) .v-icon-btn:not(.v-icon-btn--active):hover, :where(.vuetify-styles) .v-icon-btn:not(.v-icon-btn--active):focus {
    color: highlight !important;
  }
  :where(.vuetify-styles) .v-icon-btn--active:not(.v-icon-btn--disabled), :where(.vuetify-styles) .v-icon-btn--active:not(.v-icon-btn--disabled)[class*=bg-] {
    outline-color: canvastext !important;
    background: highlight !important;
    color: highlighttext !important;
  }
  :where(.vuetify-styles) .v-icon-btn--disabled {
    color: graytext;
  }
  :where(.vuetify-styles) .v-icon-btn__overlay, :where(.vuetify-styles) .v-icon-btn__underlay, :where(.vuetify-styles) .v-icon-btn .v-icon {
    forced-color-adjust: preserve-parent-color;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/labs/VIconBtn/VIconBtn.css"],"names":[],"mappings":"AAAA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,yEAAyE;EAC3E;AACF;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,wGAAwG;AAC1G;AACA;EACE;IACE,wGAAwG;EAC1G;AACF;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,uOAAuO;AACzO;AACA;EACE,sOAAsO;AACxO;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,sBAAsB;IACtB,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;EACd;EACA;IACE,uDAAuD;EACzD;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,iDAAiD;AACnD;AACA;EACE,UAAU;AACZ;AACA;EACE,6CAA6C;EAC7C,sDAAsD;EACtD,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,oCAAoC;IACpC,gCAAgC;IAChC,+BAA+B;EACjC;EACA;IACE,eAAe;EACjB;EACA;IAEE,0CAA0C;EAC5C;AACF","sourcesContent":[".v-icon-btn {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-icon-btn--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-icon-btn {\n  border-radius: 50%;\n}\n.v-icon-btn:hover > .v-icon-btn__overlay {\n  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-icon-btn:focus-visible > .v-icon-btn__overlay {\n  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-icon-btn:focus > .v-icon-btn__overlay {\n    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-icon-btn--active > .v-icon-btn__overlay, .v-icon-btn[aria-haspopup=menu][aria-expanded=true] > .v-icon-btn__overlay {\n  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-icon-btn--active:hover > .v-icon-btn__overlay, .v-icon-btn[aria-haspopup=menu][aria-expanded=true]:hover > .v-icon-btn__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));\n}\n.v-icon-btn--active:focus-visible > .v-icon-btn__overlay, .v-icon-btn[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-icon-btn__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-icon-btn--active:focus > .v-icon-btn__overlay, .v-icon-btn[aria-haspopup=menu][aria-expanded=true]:focus > .v-icon-btn__overlay {\n    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-icon-btn--variant-plain, .v-icon-btn--variant-outlined, .v-icon-btn--variant-text, .v-icon-btn--variant-tonal {\n  background: transparent;\n  color: inherit;\n}\n.v-icon-btn--variant-plain {\n  opacity: 0.62;\n}\n.v-icon-btn--variant-plain:focus, .v-icon-btn--variant-plain:hover {\n  opacity: 1;\n}\n.v-icon-btn--variant-plain .v-icon-btn__overlay {\n  display: none;\n}\n.v-icon-btn--variant-elevated, .v-icon-btn--variant-flat {\n  background: rgb(var(--v-theme-surface));\n  color: inherit;\n}\n.v-icon-btn--variant-elevated {\n  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-icon-btn--variant-flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-icon-btn--variant-outlined {\n  border: thin solid currentColor;\n}\n.v-icon-btn--variant-text .v-icon-btn__overlay {\n  background: currentColor;\n}\n.v-icon-btn--variant-tonal .v-icon-btn__underlay {\n  background: currentColor;\n  opacity: var(--v-activated-opacity);\n  border-radius: inherit;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n.v-icon-btn .v-icon-btn__underlay {\n  position: absolute;\n}\n.v-icon-btn {\n  align-items: center;\n  cursor: pointer;\n  display: inline-flex;\n  flex: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: normal;\n  height: var(--v-icon-btn-height);\n  justify-content: center;\n  outline: none;\n  position: relative;\n  transition-property: width, height, transform;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  vertical-align: middle;\n  width: var(--v-icon-btn-width);\n}\n@supports selector(:focus-visible) {\n  .v-icon-btn::after {\n    pointer-events: none;\n    border: 2px solid currentColor;\n    border-radius: inherit;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n  }\n  .v-icon-btn::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n  .v-icon-btn:focus-visible::after {\n    opacity: calc(0.25 * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-icon-btn--disabled, .v-icon-btn--loading, .v-icon-btn--readonly {\n  pointer-events: none;\n}\n.v-icon-btn--disabled {\n  opacity: 0.26;\n}\n.v-icon-btn--start {\n  margin-inline-end: 8px;\n}\n.v-icon-btn--end {\n  margin-inline-start: 8px;\n}\n\n.v-icon-btn__content {\n  align-items: center;\n  justify-content: center;\n  display: inline-flex;\n  transition: inherit;\n  transition-property: transform;\n  transform: rotate(var(--v-icon-btn-rotate, 0deg));\n}\n.v-icon-btn--loading .v-icon-btn__content {\n  opacity: 0;\n}\n.v-icon-btn__content .v-icon {\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition-property: opacity, font-size, width, height;\n  transform-origin: center;\n}\n\n.v-icon-btn__loader {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.v-icon-btn__overlay,\n.v-icon-btn__underlay {\n  border-radius: inherit;\n  pointer-events: none;\n}\n.v-icon-btn__overlay,\n.v-icon-btn__underlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.v-icon-btn__overlay {\n  background-color: currentColor;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n.v-icon-btn--active:not(:hover) .v-icon-btn__overlay {\n  --v-activated-opacity: 0;\n}\n\n@media (forced-colors: active) {\n  .v-icon-btn:focus-visible {\n    outline: 2px solid;\n    outline-offset: 2px;\n  }\n  .v-icon-btn:not(.v-icon-btn--active):hover, .v-icon-btn:not(.v-icon-btn--active):focus {\n    color: highlight !important;\n  }\n  .v-icon-btn--active:not(.v-icon-btn--disabled), .v-icon-btn--active:not(.v-icon-btn--disabled)[class*=bg-] {\n    outline-color: canvastext !important;\n    background: highlight !important;\n    color: highlighttext !important;\n  }\n  .v-icon-btn--disabled {\n    color: graytext;\n  }\n  .v-icon-btn__overlay, .v-icon-btn__underlay,\n  .v-icon-btn .v-icon {\n    forced-color-adjust: preserve-parent-color;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
